import React from "react";

const DayNightSwitcher = ({ darkMode, setDarkMode, className }) => {
  return (
    <div className={`${className}`}>
        <div className={`relative w-[3rem] h-[1.5rem]`}>
        <label className="relative block cursor-pointer">
            {/* Hidden Toggle Input */}
            <input
                type="checkbox"
                checked={darkMode}
                onChange={() => setDarkMode((prev) => !prev)}
                className="hidden"
            />

            {/* Background (Day/Night Mode) */}
            <div
            className={`absolute inset-0 w-full h-[1.5rem] rounded-full border-[2px] overflow-hidden transition-all duration-500 
                ${!darkMode ? "border-blue-300 bg-gradient-to-r from-blue-300 to-blue-100"
                        : "border-gray-900 bg-gradient-to-r from-gray-800 to-black"}`}
            >
            {/* Stars - Appear in Night Mode */}
            <div
                className={`absolute top-1 right-1 w-0.5 h-0.5 bg-white rounded-full transition-all duration-500
                ${!!darkMode ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
            />
            <div
                className={`absolute top-1.5 right-3 w-0.5 h-0.5 bg-white rounded-full transition-all duration-500
                ${!!darkMode ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
            />
            <div
                className={`absolute top-3 right-4 w-0.5 h-0.5 bg-white rounded-full transition-all duration-500
                ${!!darkMode ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
            />
            </div>

            {/* Sun/Moon Toggle */}
            <div
            className={`absolute top-[0.1rem] h-[1.3rem] w-[1.3rem] rounded-full transition-all duration-500 flex items-center justify-center border-[2px]
                ${!darkMode ? "left-[1.6rem] bg-yellow-400 border-yellow-500 transform rotate-[-25deg]" 
                        : "left-[0.1rem] bg-gray-200 border-gray-400"}`}
            >
            {/* Sun Rays / Moon Craters */}
            <div
                className={`absolute w-2 h-2 rounded-full transition-all duration-500 border-[1px]
                ${!darkMode ? "top-0 -left-2.5 bg-white border-white h-3 w-3 rotate-[25deg]" 
                            : "top-0.5 left-2.5 bg-gray-300 border-gray-400"}`}
            />
            <div
                className={`absolute w-1 h-1 rounded-full transition-all duration-500 border-[1px]
                ${!darkMode ? "top-0 -left-3.5 bg-white border-white h-2 w-2  rotate-[25deg]" 
                            : "top-3.5 left-1.5  bg-gray-300 border-gray-400"}`}
            />
            <div
                className={`absolute left-0 w-1 h-1 rounded-full transition-all duration-500 border-[1px]
                ${!darkMode ? "top-0 -left-1 bg-white border-white h-2 w-2 rotate-[25deg]" 
                            : "top-1 bg-gray-300 border-gray-400"}`}
            />

            {/* Extra Animated Craters / Sun Beams */}
            {/* <div
                className={`absolute top-1 left-3 w-2 h-2 rounded-full transition-all duration-500 
                ${darkMode ? "bg-white border-white" : "bg-gray-400 border-gray-500"}`}
            />
            <div
                className={`absolute bottom-1 right-3 w-2 h-2 rounded-full transition-all duration-500 
                ${darkMode ? "bg-white border-white" : "bg-gray-400 border-gray-500"}`}
            />
            <div
                className={`absolute bottom-2 left-2 w-1.5 h-1.5 rounded-full transition-all duration-500 
                ${darkMode ? "bg-white border-white" : "bg-gray-400 border-gray-500"}`}
            /> */}
            </div>
        </label>
        </div>
    </div>
  );
};

export default DayNightSwitcher;
